import React, { useEffect, useState } from 'react';
import invoke from '../rpc';

const invokeGameService = invoke('GameService');

const Game = ({ match }) => {
  const gameId = match.params.gameId;
  const [game, setGame] = useState();
  useEffect(() => {
    invokeGameService('GetGame', gameId).then(setGame);
  }, [gameId]);
  return (
    <div className="card mb-3">
      <h5 className="card-header text-white mb-3 bg-success">{gameId}</h5>
      <pre>
        <code>{game && JSON.stringify(game.config, null, 2)}</code>
      </pre>
    </div>
  );
};

export default Game;
